
const mergeProps = (reactInstanceProps, defaultProps) => {
    let {className, id, style, ...remainingProps} = reactInstanceProps;
    let {
        className: defaultClassName,
        id: defaultId,
        style: defaultStyle={},
        ...remainingDefaultProps
    } = defaultProps;

    className = classNames(defaultClassName, className);
    style = {...defaultStyle, ...style};
    id = id || defaultId;
    remainingProps = {...remainingDefaultProps, ...remainingProps};

    return {className, id, style, ...remainingProps};
};

//needed to trigger onChange after programmatically setting input value
/*
const e = new Event('input', { bubbles: true })
const input = document.querySelector('#js-testInput')
setNativeValue(input, "Foo");
input.dispatchEvent(e)
*/
function setNativeValue(element, value) {
    const valueSetter = Object.getOwnPropertyDescriptor(element, 'value').set;
    const prototype = Object.getPrototypeOf(element);
    const prototypeValueSetter = Object.getOwnPropertyDescriptor(prototype, 'value').set;

    if (valueSetter && valueSetter !== prototypeValueSetter) {
    	prototypeValueSetter.call(element, value);
    } else {
    valueSetter.call(element, value);
    }
}

class ReadableRoleText extends React.Component {
    constructor(props) {
        super(props);
    }
    render() {
        if(this.props.role==="primary_owner") {
            return (
                <span>Primary Owner</span>
            );
        } else if(this.props.role==="owner") {
            return (
                <span>Owner</span>
            );
        } else if(this.props.role==="admin") {
            return (
                <span>Admin</span>
            );
        } else if(this.props.role==="member") {
            return (
                <span>Member</span>
            );
        } if(this.props.role==="learner") {
            return (
                <span>Learner</span>
            );
        } if(this.props.role==="mentor") {
            return (
                <span>Mentor</span>
            );
        } else {
            return (
                <span>Other</span>
            );
        }
    }
}

class StaticImage extends React.Component {
    constructor(props) {
        super(props);
    }

    static propTypes = {
        path: PropTypes.string.isRequired,
        static_base: PropTypes.string,
        classes: PropTypes.string,
        altText: PropTypes.string
    }

    static defaultProps = {
        static_base: (mantl.static_url != undefined) ? mantl.static_url : 'https://mantlstorage.blob.core.windows.net/static/',
        classes: "",
        altText: ""
    }

    render() {
        if(this.props.altText.length > 0) {
            return (
                <img src={this.props.static_base + this.props.path } alt={this.props.altText} className={this.props.classes} />
            );
        } else {
            return (
                <img src={this.props.static_base + this.props.path } alt="Description text missing" className={this.props.classes} aria-hidden="true" />
            );
        }
    }
}

class Button extends React.Component {
    constructor(props) {
        super(props);
    }
    static propTypes = {
        classes: PropTypes.string,
        title: PropTypes.string,
        onClick: PropTypes.func.isRequired,
        disabled: PropTypes.bool,
        selected: PropTypes.bool,
        id: PropTypes.string
    }

    static defaultProps = {
        classes: "button",
        disabled: false,
        selected: false,
        id: ""
    }
    render() {
        if(this.props.disabled){
            return (
                <button type="button" role="button" className={this.props.classes} disabled="disabled" aria-disabled="true" aria-current={this.props.selected} title={this.props.title} id={this.props.id}>{this.props.children}</button>
            );
        } else {
            return (
                <button type="button" role="button" className={this.props.classes} onClick={this.props.onClick} aria-label={this.props.title} aria-current={this.props.selected} title={this.props.title} id={this.props.id}>{this.props.children}</button>
            );
        }

    }
}


function BadgeDisc(props) {
    let name = props.name || "Badge";
    let classes = props.classes || "";
    if (props.image != undefined && props.image != null && props.image.length > 0){
        return (
            <img src={props.image} className={"badge-disc " + classes} alt={name + " Artwork"} data-component="BadgeDisc" />
        );
    } else {
        return (
            <span className={"icon-disc icon-disc--muted " + classes}><Icon classes="icon-image" title="Default Badge Artwork Symbol"></Icon></span>
        );
    }

}

class Icon extends React.Component {
    constructor(props) {
        super(props);
    }

    static propTypes = {
        classes: PropTypes.string.isRequired,
        title: PropTypes.string
    }

    static defaultProps = {
        title: ""
    }

    render() {
        if(this.props.title.length > 0){
            return (
                <i className={this.props.classes} title={this.props.title}><span className="screenreader">{this.props.title}</span></i>
            );
        } else {
            return (
                <i className={this.props.classes} aria-hidden="true"></i>
            );
        }
    }
}

class LoadingSpinner extends React.Component {
    constructor(props) {
        super(props);
    }
    render() {
        return (
            <div className="spinner spinner--pulsing"><div className="spinner-ring"></div></div>
        );
    }
}


class FormattedDate extends React.Component {
    constructor(props) {
        super(props);
    }
    render() {
        var dateString = "-";
        if(this.props.date != null) {
            dateString = fecha.format(new Date(this.props.date), 'MMM Do, YYYY');
        }
        return (
          <time dateTime={this.props.date}>{dateString}</time>
        );
    }
}

class FormattedUnixDate extends React.Component {
    constructor(props) {
        super(props);
    }
    render() {
        var dateString = "-";
        if(this.props.date != null) {
            let unixTime = parseInt(this.props.date); //sometimes we get strings
            dateString = fecha.format(new Date(unixTime), 'MMM Do, YYYY');
        }
        return (
          <time dateTime={this.props.date}>{dateString}</time>
        );
    }
}

function reactFixRowsCols(component) {
    $(component).find("[data-row]").each(function(){
        $(this).attr("row","row");
    });
    $(component).find("[data-column]").each(function(){
        $(this).attr("column",$(this).attr("data-column"));
    });
    $(component).find("[data-container]").each(function(){
        $(this).attr("container",$(this).attr("data-container"));
    });
}

class CollapsibleList extends React.Component {
    //Takes an array of strings
    constructor(props){
        super(props);
        this.collapsibleRef = React.createRef();
    }

    static propTypes = {
        list: PropTypes.array.isRequired,
        header: PropTypes.string,
        descHeader: PropTypes.string
    }

    static defaultProps = {
        header: "Toggle List",
        descHeader: null
    }

    componentDidMount(){
        $(this.collapsibleRef.current).collapsible();
    }

    render() {
        let listItems = this.props.list.map(
            (item,index) => <li className="collection-item" key={"key_" + index}>{item}</li>
        )
        let ariaLabel = (this.props.descHeader == null) ? "Open/Close Toggle List" : this.props.descHeader;
        return (
            <div className="collapsible" ref={this.collapsibleRef}>
                <button className="collapsible-header nowrap" aria-label={ariaLabel}>{this.props.header} <Icon classes="icon-chevron-down icon--sm icon--disabled"></Icon></button>
                <div className="collapsible-body">
                    <ul className="collection">{listItems}</ul>
                </div>
            </div>
        );
    }
}


class PaginationOffsetLimit extends React.Component {
    constructor(props) {
        super(props);
        this.goTo = this.goTo.bind(this);
        this.onClickNext = this.onClickNext.bind(this);
        this.onClickPrev = this.onClickPrev.bind(this);
        this.state = {
            count: 0,
            limit: 5,
            offset: 0,
            currentPage: 1
        };
    }

    static propTypes = {
        classes: PropTypes.string,
        maxVisible: PropTypes.number,
        limit: PropTypes.number,
        offset: PropTypes.number,
        count: PropTypes.number,
        onChangePage: PropTypes.func.isRequired,
    }

    static defaultProps = {
        classes: "",
        maxVisible: 5,
        limit: 5,
        offset: 0,
        count: 0
    }

    componentDidMount(){
        this.setState({
            count: this.props.count,
            limit: this.props.limit,
            offset: this.props.offset
        })
    }

    goTo(page, e) {
        if (e) {
            e.preventDefault();
        }
        // console.log("goTo " + page);
        if(this.state.currentPage != page){
            var newOffset = (page - 1) * this.state.limit;
            this.setState({
                offset: newOffset,
                currentPage: page
            }, () => {
                this.props.onChangePage(newOffset); //callback to setstate just to be sure
            });
        }
    }

    onClickNext(e) {
        e.preventDefault();
        var page = this.state.currentPage;
        if (page < Math.ceil(this.props.count/this.props.limit)) {
            this.goTo(page + 1);
        }
    }

    onClickPrev(e) {
        e.preventDefault();
        if (this.state.currentPage > 1) {
            this.goTo(this.state.currentPage - 1);
        }
    }

    render() {
        var classes = this.props.classes || '',
        p = this.props,
        s = this.state,
        maxPage = Math.ceil(this.props.count/this.props.limit),
        skip = 0; //offset of page numbers


        if (s.currentPage > p.maxVisible - 1 && s.currentPage < maxPage) {
            skip = s.currentPage - p.maxVisible + 1;
        } else if (s.currentPage === maxPage && maxPage >= p.maxVisible) {
            skip = s.currentPage - p.maxVisible;
        }

        var iterator = Array.apply(null, Array( ((maxPage < p.maxVisible) ? maxPage : p.maxVisible) )).map(function(v, i) {
            return skip + i + 1;
        });

        return (
            <nav className={classes} role='navigation' aria-label='Pagination Navigation'>
                <ul className='group'>
                    <li className={'group-item ' + (s.currentPage === 1 ? 'is-disabled' : '')}>
                        <a href="#" onClick={this.goTo.bind(this, 1)}>
                            <span aria-hidden="true" className="icon-chevron-left icon--smaller"></span>
                            <span className="sr-only"> First</span>
                        </a>
                    </li>
                    <li className={'group-item ' + (s.currentPage === 1 ? 'is-disabled' : '')}>
                        <a href="#" onClick={this.onClickPrev}>
                            <span className="sr-only">Prev</span>
                        </a>
                    </li>
                    {iterator.map(function(page) {
                        return (
                            <li key={page}
                                onClick={() => this.goTo(page)}
                                className={'group-item ' + (s.currentPage === page ? 'is-active' : '')}>
                                <a href="#" data-page={page} aria-current={(s.currentPage === page ? 'true' : 'false')}>{page}</a>
                            </li>
                        );
                    }, this)}
                    <li className={'group-item ' + (s.currentPage === maxPage ? 'is-disabled' : '')}>
                        <a href="#" onClick={this.onClickNext}>
                            <span className="sr-only">Next</span>
                        </a>
                    </li>
                    <li className={'group-item ' + (s.currentPage === maxPage ? 'is-disabled' : '')}>
                        <a href="#" onClick={() => this.goTo(maxPage)}>
                            <span className="sr-only">Last </span>
                            <span aria-hidden="true" className="icon-chevron-right icon--smaller"></span>
                        </a>
                    </li>
                </ul>
            </nav>
        );
    }
};

class Markdown extends React.Component {
    constructor(props) {
        super(props);
    }
    render() {
        if (typeof markdownit != "undefined") {
            var markdown = new markdownit();
            var result = markdown.render(this.props.source);
            return (
                <div dangerouslySetInnerHTML={{__html:result}}></div>
            );
        } else {
            console.error('Markdown-It not loaded. Unable to parse markdown blocks.');
            return (
              <pre>{this.props.source}</pre>
            );
        }
    }
}
